import { timeout } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Import global data service
import { DataService, Loading } from 'src/app/Services/Data/data.service';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {
  // quotes
  quotes: any = [];

  // user login
  login: boolean = false;
  user_data: any;

  // Loading
  loading: Loading;

  //error
  error_messages: any = [];

  // Data
  data: any = [];
  salesforce: any = [];
  document_group: any = [];

  salesforce_session_data: any;

  loadInfo() {
    this.data = this.dataService.getData();
    this.salesforce = this.dataService.getSalesforceData();
    this.document_group = this.dataService.getDocumentGroup();
  }

  constructor(private router: Router, private dataService: DataService) {
    this.loading = dataService.getLoading();
  }

  ngOnInit() {
    this.loadSalesforceDataIntoDataService();
    this.dataService.resetData();
    this.updateLoading(true, '');
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    this.loadInfo();
  }
  reload() {
    this.loadSalesforceDataIntoDataService();
    this.dataService.resetData();
    this.updateLoading(true, '');
    this.loadSalesforceDataFromParentFrameAndUpdateUserDB();
    this.loadInfo();
  }
  async loadSalesforceDataIntoDataService() {
    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    this.dataService.maintenanceCheck(this.salesforce_session_data);

    var sf_token = this.salesforce_session_data.sf_token;
    var sf_refresh = this.salesforce_session_data.sf_refresh;
    var sf_org_id = this.salesforce_session_data.sf_org_id;
    var sf_user_id = this.salesforce_session_data.sf_user_id;
    var instance_url = this.salesforce_session_data.instance_url;
    var record_type = this.salesforce_session_data.record_type;
    var record_id = this.salesforce_session_data.record_id;
    var context = this.salesforce_session_data.context;
    if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      this.updateLoading(false, '');
      this.updateError(this.dataService.salesforce_session_error);
      this.quotes = [];
      this.login = true;
      return;
    }
    // set information in data service
    this.dataService.setSalesforceRefresh(sf_refresh);
    this.dataService.setSalesforceToken(sf_token);
    this.dataService.setSalesforceOrgId(sf_org_id);
    this.dataService.setSalesforceUserId(sf_user_id);
    this.dataService.setSalesforceInstanceUrl(instance_url);
    this.dataService.setSalesforceRecordType(record_type);
    this.dataService.setSalesforceRecordId(record_id);
    this.dataService.setSalesforceContext(context);
    this.getRecordEmails(record_type, instance_url, sf_token);
  }
  getRecordEmails(record_type, instance_url, sf_token) {
    var data = {
      sf_token: sf_token,
      instance_url: instance_url,
      record_type: record_type
    };
    this.dataService
      .apiPostCall('/api/get_emails', data)

      .subscribe((result) => {
        try {
          var res: any = JSON.parse(result);
          this.dataService.setRecordEmails(res);
        } catch {}
      });
  }

  async loadSalesforceDataFromParentFrameAndUpdateUserDB() {
    try {
      this.salesforce_session_data = await this.dataService
        .apiGetCall('/api/salesforce_session_data')
        .toPromise();

      this.dataService.maintenanceCheck(this.salesforce_session_data);

      var sf_token = this.salesforce_session_data.sf_token;
      var sf_refresh = this.salesforce_session_data.sf_refresh;
      var sf_org_id = this.salesforce_session_data.sf_org_id;
      var sf_user_id = this.salesforce_session_data.sf_user_id;
      var instance_url = this.salesforce_session_data.instance_url;

      if (!this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
        this.updateLoading(false, '');
        this.updateError(this.dataService.salesforce_session_error);
        this.quotes = [];
        this.login = true;
        return;
      }
      // send information to db: user will be added if not already found in db otherwise user data will be updated
      this.user_data = {
        sf_user_id: sf_user_id,
        sn_token: '',
        sn_refresh: '',
        sf_org_id: sf_org_id,
        sf_token: sf_token,
        sf_refresh: sf_refresh,
        instance_url: instance_url
      };
      this.updateLoading(true, "Checking validity of user's token.");
      this.dataService
        .apiGetCall('/api/check_if_user_in_db_with_valid_sn_token?user_id=' + sf_user_id)

        .subscribe((result) => {
          // ;

          if (!(result.in_db == true && result.valid_sn_token == true)) {
            // ;
            // login before continuing

            this.updateLoading(false, '');
            this.quotes = [];
            this.login = true; // this variable makes the login div visiable
          } else {
            // ;
            //////////////////////////// user data has all the information needed to connect to signnow ///////////////////////////////
            var sn_token = result.sn_token;
            var sn_refresh = result.sn_refresh;
            this.user_data.sn_token = sn_token;
            this.user_data.sn_refresh = sn_refresh;
            this.dataService.setSignNowOwnerEmail(result.sn_email);
            /*
            Load quote List
          */
            this.load_quote_list();
            //////////////////////////////// update user db /////////////////////////////////////////////////////////////////////////////
            if (this.user_data.sn_token != '') {
              this.dataService.apiPostCall('/api/update_user_db', JSON.stringify(this.user_data));
            }
          }
        });
    } catch {}
  }

  valid_value(value): boolean {
    if (value == null || value == undefined || typeof value == 'undefined') {
      return false;
    }
    return true;
  }

  load_quote_list() {
    var salesforce_data = this.dataService.getSalesforceData();
    var data = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      record_id: salesforce_data.record_id
    };
    this.dataService
      .apiPostCall('/api/get_quote_list', data)

      .subscribe((result) => {
        var valid_quotes = [];
        var valid_count = 0;
        for (var i = 0; i < result.length; i++) {
          var extension = /[.]/.exec(result[i].Name) ? /[^.]+$/.exec(result[i].Name) : undefined;
          if (extension != undefined) {
            valid_quotes[valid_count] = result[i];
            valid_quotes[valid_count].CreatedDate = this.convertTime(valid_quotes[valid_count].CreatedDate);
            valid_count++;
          }
        }
        this.quotes = valid_quotes;
        this.updateLoading(false, '');
      });
  }

  convertTime(timestamp) {
    var a = new Date(timestamp + ' UTC');
    var year = a.getFullYear();
    var month = a.getMonth();
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes();
    month++;

    var time = '';
    if (min < 10) {
      time = date + '/' + month + '/' + year + ' ' + hour + ':0' + min;
    } else {
      time = date + '/' + month + '/' + year + ' ' + hour + ':' + min;
    }
    return time;
  }

  send_quote_to_signnow(quote) {
    var quote_id = quote.Id;
    var quote_name = quote.Name;
    //post_quote_to_signnow
    var salesforce_data = this.dataService.getSalesforceData();
    var data = {
      sf_token: salesforce_data.sf_token,
      instance_url: salesforce_data.instance_url,
      quote_id: quote_id,
      quote_name: quote_name
    };
    this.updateLoading(true, 'Sending quote to Signnow.');
    this.dataService
      .apiPostCall('/api/post_quote_to_signnow', data)
      .pipe(timeout(300000))

      .subscribe(
        (result) => {
          this.dataService.setDocumentId(JSON.parse(result).id);
          this.updateLoading(false, '');
          this.router.navigate(['preview'], { queryParams: { sending_type: 'quotes' } });
        },
        (error) => {
          this.updateLoading(false, '');
          if (error.status == 503 || error.status == 504) {
            this.updateError('Call timed out.');
          } else {
            this.updateError(error.error);
          }
        }
      );
  }

  logout_user() {
    this.updateLoading(true, 'logging out user!');
    this.user_data.sn_token = '';
    this.user_data.sn_refresh = '';
    this.user_data.sn_email = '';
    this.dataService
      .apiPostCall('/api/update_user_db', JSON.stringify(this.user_data))

      .subscribe(() => {
        this.updateLoading(false, '');
        this.quotes = [];
        this.login = true;
      });
  }

  login_user(email, password) {
    // when login div button is submited we login to singnnow
    var login_data = {
      username: email,
      password: password
    };
    this.updateLoading(true, 'Requesting to login with SignNow.');
    this.dataService
      .apiPostCall('/api/login_to_signnow', JSON.stringify(login_data))

      .subscribe((result) => {
        this.updateLoading(true, 'Login with SignNow response returned.');
        if (result.valid_credentials == true) {
          this.clearErrors();
          this.login = false;
          var sn_token = result.sn_token;
          var sn_refresh = result.sn_refresh;
          this.user_data.sn_token = sn_token;
          this.user_data.sn_refresh = sn_refresh;
          this.user_data.sn_email = email;
          this.dataService.setSignNowOwnerEmail(email);
          ////////////////// recived a valid token so we can load the documents from signnow at this point ///////////////////////
          //this.getAllFoldersAndDocuments();
          //////////////////////////////// update user db /////////////////////////////////////////////////////////////////////////////

          this.updateLoading(
            true,
            'Validating SignNow login credentials and updating user data on this account.'
          );
          this.dataService
            .apiPostCall('/api/update_user_db', JSON.stringify(this.user_data))

            .subscribe(() => {
              this.updateLoading(false, '');
              this.reload();
            });
        } else {
          this.updateLoading(false, '');
          this.updateError(
            'Invalid user credentials. Please enter valid user credentials to log in to SignNow.'
          );
        }
      });
  }

  clearErrors() {
    this.error_messages = [];
  }

  updateLoading(state: boolean, msg: string) {
    this.loading.update(state, msg);
  }

  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }

  removeErrorMessage(error_message) {
    for (var i = 0; i < this.error_messages.length; i++) {
      if (error_message == this.error_messages[i]) {
        //delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  search_quotes(value) {
    // Declare variables
    var input, filter, table, tr, td, i;
    input = value;
    filter = input.toUpperCase();
    table = document.getElementById('QuoteTable');
    tr = table.getElementsByTagName('tr');

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName('td')[0];
      if (td) {
        if (td.innerText.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = '';
        } else {
          tr[i].style.display = 'none';
        }
      }
    }
  }

  reloadAfterSSOLogin() {
    this.login = false;
    this.reload();
  }
}
